/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioClasificacionesCV from './controladorVista/formularioClasificacionesCV';
import TablaClasificacionesCV from './controladorVista/tablaClasificacionesCV';
import { estadoIncial, reductor } from './reductorClasificaciones';

const Clasificaciones: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaClasificacionesCV />
        <FormularioClasificacionesCV />
    </ProveedorEstado>
);

export default Clasificaciones;
